import { useApolloClient } from '@apollo/client';

import { ensureNormalizedCacheObjectClient } from './ensureNormalizedCacheObjectClient';

export const useApolloTypedClient = () => {
  const apolloClient = useApolloClient();
  const typedClient = ensureNormalizedCacheObjectClient(apolloClient);

  return typedClient;
};
